import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import Button from 'components/button';
import styles from './styles.css';

export default class OrderLogs extends Component {
    static propTypes = {
        logs: PropTypes.array.isRequired,
    };

    state = {
        visibleInvoices: [],
    };

    handleInvoicesToggle(id) {
        return () => {
            let visibleInvoices;
            if (this.state.visibleInvoices.includes(id)) {
                visibleInvoices = this.state.visibleInvoices.filter(other => other !== id);
            } else {
                visibleInvoices = [...this.state.visibleInvoices, id];
            }
            this.setState({visibleInvoices});
        };
    }

    renderInvoices(invoices) {
        return (
            <Fragment>
                {invoices.map(invoice => (
                    <div key={invoice.id}>
                        <Link to={invoice.file} target='_blank'>
                            <i className='material-icons'>insert_drive_file</i> {invoice.name}
                        </Link>
                    </div>
                ))}
            </Fragment>
        );
    }

    render() {
        const {visibleInvoices} = this.state;

        return (
            <table className={styles.root}>
                <thead className={styles.header}>
                    <tr>
                        <th>Fecha</th>
                        <th>Estado desde</th>
                        <th>Estado hacia</th>
                        <th>Responsable</th>
                        <th>Comentarios</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {this.props.logs.map((log, index) => {
                        const bgClass = index % 2 !== 0 ? styles.odd : styles.even;
                        return (
                            <Fragment key={log.id}>
                                <tr className={classNames(styles.row, bgClass)}>
                                    <td>
                                        <span className={styles.key}>Fecha: </span>
                                        {moment(log.created).format('LLL')}
                                    </td>
                                    <td>
                                        <span className={styles.key}>Estado desde: </span>
                                        {log.statusFrom.name}
                                    </td>
                                    <td>
                                        <span className={styles.key}>Estado hacia: </span>
                                        {log.statusTo.name}
                                    </td>
                                    <td>
                                        {log.createdBy && (
                                            <Fragment>
                                                <span className={styles.key}>Responsable: </span>
                                                {log.createdBy.firstName} {log.createdBy.lastName}
                                            </Fragment>
                                        )}
                                    </td>
                                    <td>
                                        {log.notes && (
                                            <Fragment>
                                                <span className={styles.key}>Comentarios: </span>
                                                {log.notes}
                                            </Fragment>
                                        )}
                                    </td>
                                    <td>
                                        {log.invoices.length > 0 && (
                                            <Button theme='gray' onClick={this.handleInvoicesToggle(log.id)}>
                                                {this.state.visibleInvoices.includes(log.id)
                                                    ? 'Ocultar facturas'
                                                    : 'Ver facturas'
                                                }
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                                {visibleInvoices.includes(log.id) && (
                                    <tr className={classNames(styles.invoiceList, bgClass)}>
                                        <td colSpan={6}>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>Facturas: </td>
                                                        <td>{this.renderInvoices(log.invoices)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </Fragment>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/order-logs/index.js